import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({
	level: {
		height: "150px",
		width: "85%",
		margin: "10px auto",
		borderRadius: "15px",
		padding: "15px",
		background: "linear-gradient(-45deg, #e7e7e7 0%, #e7e7e7 46%, #F8F8F8 50%, #e7e7e7 65%, #e7e7e7 100%)",
		backgroundSize: "200% 200%",
		animation: "$pulse 0.8s cubic-bezier(0.55, 0.085, 0.68, 0.53) infinite; infinite",
		"user-select": "none",
	},

	"@keyframes pulse": {
		"0%": {
			backgroundPosition: "-40% 0%"
		},

		"70%": {
			backgroundPosition: "-250% 0%"
		},

		"100%": {
			backgroundPosition: "-250% 0%"
		},
	}
});

function SkeletonLevel(props){
	const { classes} = props;

	return (
		<div
			className={classes.level}/>
	);
}

SkeletonLevel.propTypes = {
	classes: PropTypes.shape({
		level: PropTypes.string.isRequired,
	}).isRequired,

};

export default withStyles(styles)(SkeletonLevel);
